import {BBModel} from '../bb_model';
import {context} from '../constants/context';
import {halClient} from '../hal';

const eventChain = {
    query(company, params) {
        return new Promise((resolve, reject) => {
            if (!company.$has('event_chains')) {
                reject('company does not have event_chains');
            } else {
                company.$get('event_chains', params).then((resource) => {
                        return resource.$get('event_chains', params).then((event_chains) => {
                                event_chains = Array.from(event_chains).map(event_chain =>
                                    new BBModel.EventChain(event_chain));
                                return resolve(event_chains);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    },

    async queryById(companyId, eventChainId) {
        const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/event_chains/${eventChainId}`;
        return new BBModel.EventChain(await halClient.$get(url), {});
    },

    queryEventChainCollection(company, params) {
        return new Promise((resolve, reject) => {
            if (!company.$has('event_chains')) {
                resolve([]);
            } else {
                company.$get('event_chains', params).then((resource) => {
                        const collection = new BBModel.BBCollection(resource);
                        return resolve(collection);
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    }
};

export {
    eventChain
};

